import { Button, Fade, Grid, Modal, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { alertService } from 'src/components/toaster/alert.service';
// import ProductService from './../../services/product/product.service';
import CompanyService from './../../services/company/company.service';



const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  ModalBox: {
    marginLeft: "36px",
    marginTop: "36px",
  },
  name: {
    marginTop: "20px",
    fontSize: '15px',
    color: '#0C1234 !important',
    fontWeight: "500",
    font: "Roboto",
    lineHeight: "22px"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    outline: 'none',
    borderRadius: '12px',
    width: "370px",
    maxWidth: '370px',
    // maxHeight: '370px',
    boxShadow: theme.shadows[5],
  },
  container: {
    // width: "370px",
    position: "relative",
    marginLeft: "-13px"
  },
  buttonBox: {
    marginLeft: "97px",
    marginBottom: "28px",
    marginRight: "23px",
    marginTop: "12px",
    display: "flex",

  },
  saveContainer: {
    marginTop: "30px",
    marginLeft: "14%",
    marginBottom: "30px"
  },
  title: {
    fontSize: '15px',
    color: '#0C1234 !important',
    fontWeight: '500',
    font: 'Roboto',
    lineHeight: '20px',
  },
  saveButton: {
    margin: "0px 0px 0px 20px"
  }

}));


const PublishModal = ({ deleteProductModal, closeEditModal, product }) => {
  const history = useHistory();
  const classes = useStyles();
  const companyService = new CompanyService();

  const closePopUp = () => {
    closeEditModal(false)
  }




  const handleSave = () => {
    console.log(product, "productId")
    companyService.deleteProductComp(product).
      then((success) => {
        alertService.success("Product has been Deleted successfully.")
        setTimeout(() => window.location.href = '/app/additional-information?start_point=add_product', 1000);
      })
      .catch((error) => console.log(':: error', error));
  }
  // console.log(publishModalOpen, "coming")
  // console.log(product, "productIdModal")
  // console.log(isPublished, "isPublished")
  // console.log(product, "productId")



  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        className={classes.modal}
        open={deleteProductModal}
        onClose={closePopUp}
        closeAfterTransition
        // BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={true}>
          <>

            <div className={classes.paper}>
              <Grid className={classes.ModalBox}>
                <Grid item className={classes.container} >
                  {/* <CloseIcon className={classes.icon} onClick={closePopUp} /> */}
                  <Typography className={classes.title}>Are you sure you want to Delete this product?</Typography>
                  <Grid
                    item
                    container
                    className={classes.saveContainer}
                  >
                    <Grid item xs={12}>
                      <span
                        style={{
                          fontSize: '12px',
                          color: '#263344',
                          cursor: 'pointer',
                          marginTop: '8px',
                          marginLeft: "121px"
                        }}
                        onClick={closePopUp}
                      >
                        Cancel
                      </span>
                      <Button
                        className={classes.saveButton}
                        variant="contained"
                        color="primary"
                        onClick={handleSave}
                      >
                        <span style={{ fontSize: '12px' }}>
                          Delete
                        </span>
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </>
        </Fade>
      </Modal>

    </>
  )
}

export default PublishModal
